import {
  GetApPayeeInfoResponseAgentReceiveSetting,
  GetApPayeeInfoResponseApInvoiceTransactionDefaultValue,
  GetApPayeeInfoResponseApPayeeContactSetting,
  GetApPayeeInfoResponseContactOfficeMember,
  GetApPayeeInfoResponseContactOfficeMembersItem,
  GetApPayeeInfoResponseSupplierUploadSetting,
} from 'ap-openapi';

export enum SECTION_KEYS {
  PIC = 'PIC',
  GEN = 'GEN',
  TRANSACTION = 'TRANSACTION',
  EMAIL = 'EMAIL',
  NULL = 'NULL',
}

export enum InvoiceReceiveEmailProcessType {
  PAYMENT_REQUEST = 'payment_request',
  RECEIVED_INVOICE = 'received_invoice',
}

type baseDataProps = {
  id: string;
};

export type GeneralInformationData = baseDataProps & {
  display_name: string;
};

export type PICAndContractDetailData = baseDataProps & {
  ap_payee_contact_setting?: GetApPayeeInfoResponseApPayeeContactSetting;
  contact_office_members?: GetApPayeeInfoResponseContactOfficeMembersItem[];
  contact_person_email?: string;
  contact_person_full_address?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  dept_name?: string;
};

export type WebReceivingMethodData = {
  supplierUploadSetting?: GetApPayeeInfoResponseSupplierUploadSetting;
  is_supplier_upload_setting_enabled?: boolean;
  is_payee_active?: boolean;
};

export type ProxyReceivingMethodData = {
  is_proxy_receipt_receiving_method_enabled?: boolean;
  agentReceiveSetting?: GetApPayeeInfoResponseAgentReceiveSetting;
};

export type EmailReceivingMethodData = {
  is_invoice_receive_email_setting_existed?: boolean;
  invoice_receive_email_address?: string;
  invoice_receive_email_process_type?: InvoiceReceiveEmailProcessType;
  contact_office_member?: GetApPayeeInfoResponseContactOfficeMember;
  is_invoice_receive_mail_address_issued?: boolean;
};

export type ReceivingMethodData = baseDataProps & {
  webReceivingMethod: WebReceivingMethodData;
  proxyReceivingMethod: ProxyReceivingMethodData;
  emailReceivingMethod: EmailReceivingMethodData;
};

export type PaymentRuleData = {
  payment_closing_date?: string; // Formatted string like "31日"
  payment_month?: string; // Translated string like "翌月"
  payment_due_date?: string; // Formatted string like "31日"
  payment_holiday_rule?: string; // Translated string like "前倒し"
};

export type DataMaster = {
  generalInformation: GeneralInformationData;
  PICAndContractDetail: PICAndContractDetailData;
  receivingMethod: ReceivingMethodData;
  paymentRule: PaymentRuleData;
  transactionDefaultValue?: GetApPayeeInfoResponseApInvoiceTransactionDefaultValue;
};

export enum AnchorItemKey {
  GENERAL_INFORMATION = 'general-information',
  PIC_AND_CONTACT_INFORMATION = 'pic-and-contact-information',
  RECEIVING_METHOD = 'receiving-method',
  AI_AGENT = 'ai-agent',
  DEFAULT_PAYMENT_METHOD = 'default-payment-method',
  PAYMENT_RULE = 'payment-rule',
  TRANSACTION_DEFAULT_VALUE = 'transaction-default-value',
}

export type PICAndContactInformationForm = {
  contact_office_member_ids: string[];
  contact_person_name?: string;
  dept_name?: string;
  contact_person_email?: string;
  contact_person_phone_number?: string;
  postal_code?: string;
  prefecture_id?: number;
  address?: string;
};

export type TransactionDetailForm = {
  name?: string;
  dept_id?: string;
  ap_item_id?: string;
  project_code_id?: string;
  is_tax_included?: boolean;
  default_currency?: string;
};

export type ApInvoiceReceiveEmailSetting = {
  process_invoice_type?: InvoiceReceiveEmailProcessType;
};

export type EmailReceivingMethodForm = {
  contact_office_member_id?: string;
  ap_invoice_receive_email_setting?: ApInvoiceReceiveEmailSetting;
};
